<template>
  <LayoutDashboard title="Empresas">
    <v-card outlined>
      <v-card-title>
        <v-btn color="primary" @click="cadastrarEmpresa" outlined v-if="$helper.verificaPermissao('cadastrar-empresa')">Cadastrar</v-btn>
        <v-spacer></v-spacer>
        <v-text-field outlined dense v-model="search" append-icon="search" label="Pesquisar" single-line hide-details> </v-text-field>
      </v-card-title>
      <v-card-text>
        <v-data-table :headers="headers" :items="getEmpresas" :search="search" dense>
          <template v-slot:item.action="{ item }">
            <v-btn color="primary" outlined small @click="$router.push({ name: 'empresaEditar', params: { id: item.id } })" v-if="$helper.verificaPermissao('visualizar-empresa')">Visualizar</v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </LayoutDashboard>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      search: "",
      headers: [
        { text: "#", value: "id", sortable: false },
        { text: "Razão Social", align: "left", sortable: false, value: "razao_social" },
        { text: "CNPJ", value: "cnpj" },
        { text: "Ações", value: "action", sortable: false },
      ],
    };
  },
  computed: {
    ...mapGetters(["getEmpresas"]),
  },
  methods: {
    ...mapActions(["visualizarEmpresa", "listarEmpresa", "cadastrarEmpresa"]),
  },
  created() {
    this.listarEmpresa();
  },
};
</script>
